import {
    Box,
    Flex,
    Text,
    Stack,
    Icon,
    Link,
    useBreakpointValue,
    IconButton,
    Spacer,
    Separator,
} from "@chakra-ui/react";
import { Tooltip } from '../components/ui/tooltip';
import { useColorModeValue } from "../components/ui/color-mode";
import { FaGithub, FaLinkedin } from "react-icons/fa";
import { Link as RouterLink } from "react-router-dom";
import { IoLogoInstagram } from "react-icons/io5";
import { FaHeart } from "react-icons/fa6";
import StatusSign from "./StatusSign";
import { Fragment } from "react";

const accounts = [
    {
        url: "https://github.com/labchron",
        label: "Github Account",
        type: "gray",
        icon: <FaGithub />,
    },
    {
        url: "https://linkedin.com/company/labchron",
        label: "LinkedIn Account",
        type: "linkedin",
        icon: <FaLinkedin />,
    },
    {
        url: "https://instagram.com/labchron",
        label: "Instagram Account",
        type: "instagram",
        icon: <IoLogoInstagram />,
    },
];

const links = [
    { label: "Blog", href: "/blog", disabled: true },
    { label: "Privacy", href: "/privacy", disabled: false },
    { label: "Imprint", href: "/imprint", disabled: false },
];

const SocialMediaIcons = () => {
    return (
        <Stack direction="row" gap={5}>
            {accounts.map((account, index) => (
                <IconButton
                    key={index}
                    aria-label={account.label}
                    rounded="md"
                    css={{
                        ...(account.type === "instagram"
                            ? {
                                  bg: "linear-gradient(45deg, #833ab4, #fd1d1d, #fcb045)",
                                  color: "white",
                                  _hover: {
                                      bg: "linear-gradient(45deg, #833ab4, #fd1d1d, #fcb045)",
                                  },
                              }
                            : {})
                    }}
                    colorPalette={account.type !== "instagram" ? account.type : undefined}
                    asChild><a href={account.url} target="_blank" rel="noopener noreferrer">{account.icon}</a></IconButton>
            ))}
        </Stack>
    );
};


const CustomLink = ({ label, href, disabled, color: linkColor, ...props }) => {
    const linkStyleProps = disabled
        ? {
              color: "gray.500",
              pointerEvents: "none",
              textDecoration: "none",
          }
        : {
              color: linkColor,
              _hover: { textDecoration: "underline" },
          };

    return (
        <Tooltip content={disabled ? "Coming Soon" : ""} disabled={!disabled}>
            <Link fontSize="sm" {...linkStyleProps} {...props} asChild><RouterLink to={href}>
                    {label}
                </RouterLink></Link>
        </Tooltip>
    );
};

const FooterLinks = () => {
    const isMobile = useBreakpointValue({ base: true, md: false });
    const linkColor = useColorModeValue("white", "white");

    return (
        <Flex direction={isMobile ? "column" : "row"} wrap="wrap" justify="center" align="center">
            {links.map((link, index) => (
                <Fragment key={index}>
                    <Flex wrap="wrap" justify="center" align="center" my={2}>
                        <CustomLink label={link.label} href={link.href} disabled={link.disabled} color={linkColor}/>
                        {index < links.length - 1 && !isMobile && <Separator orientation="vertical" mx={2} h="1rem" />}
                    </Flex>
                </Fragment>
            ))}
        </Flex>
    );
};

export const FooterInfo = () => {
    const currentYear = new Date().getFullYear();
    const bg = useColorModeValue("primary.900", "primary.900");
    const textColor = useColorModeValue("white", "white");
    const separatorColor = useColorModeValue("primary.500", "primary.500");
    const mutedColor = useColorModeValue("gray.400", "gray.400");

    return (
        <Box as="footer" width="100%" bg={bg} color={textColor} p={{ base: '0em 0em 4em 0em', md: '0em 0em 2em 0em' }} marginTop="auto">
            <Separator bgColor={separatorColor} borderColor={separatorColor} variant="solid" height={1} maxWidth="full" mx="auto" />
            <Flex direction={{ base: "column", md: "row" }} justify="space-between" align="center" wrap="wrap" pt={'2'}>
                <Flex direction="column" align={{ base: "center", md: "flex-start" }}  mx={5}>
                    <Text fontSize={{ base: "sm", md: "md" }} mb={2}>
                        &copy; {currentYear} LabChron
                    </Text>
                    <StatusSign />
                </Flex>

                <Spacer />

                <Box mb={{ base: 4, md: 0 }} mt={{ base: 4, md: 0 }}>
                    <FooterLinks />
                </Box>

                <Spacer />

                <Flex direction="column" align={{ base: "center", md: "flex-start" }} alignItems="center" mx={5}>
                    <Stack direction="row" gap={5} pt={{ base: 4, md: 0 }} alignItems="center">
                        <SocialMediaIcons />
                    </Stack>
                    <Text fontSize="sm" color={mutedColor} display="flex" alignItems="center" justifyContent={{ base: "center", md: "start" }} mt={2}>
                        Made with <Icon color="red.500" mx={1} asChild><FaHeart /></Icon> in Ulm & Stuttgart
                    </Text>
                </Flex>
            </Flex>
        </Box>
    );
};
